import Vue from "vue"
import Search from "./Search"
import Vuetify from "vuetify"
Vue.use(Vuetify)

Vue.config.productionTip = false

new Vue({
  render: h => h(Search),
  vuetify: new Vuetify(),
}).$mount("#search-app")
